import { ApiClient } from "./ApiClient";
import { ValueOf } from "../../utils/utils";

export interface NotificationType {
    Id: NotificationTypeId;
    LabelKey: string;
}

export const getNotificationTypes = async (apiClient: ApiClient): Promise<NotificationType[]> => {
    return apiClient.request<NotificationType[]>("/servicecall/getnotificationtypes", {}, mockNotificationTypes);
};

export const NOTIFICATION_TYPES = {
    MACHINE_STOP: 20,
    FAULT_WITHOUT_STOP: 10,
    PROGRAMMING_SOFTWARE: -100,
    CLARIFICATION_SPARE_PARTS: 50,
    OTHER: 40,
    MAINTENANCE_REQUEST: 120,
    SPARE_PARTS_ORDER: 140,
    APPLICATION_ISSUES: 80
};

export type NotificationTypeId = ValueOf<typeof NOTIFICATION_TYPES>;

export type NotificationTypeName = keyof typeof NOTIFICATION_TYPES;

const mockNotificationTypes: NotificationType[] = [
    {
        Id: NOTIFICATION_TYPES.MACHINE_STOP,
        LabelKey: "Maschinenstillstand"
    },
    {
        Id: NOTIFICATION_TYPES.FAULT_WITHOUT_STOP,
        LabelKey: "Störung ohne Stillstand"
    },
    {
        Id: NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE,
        LabelKey: "Programmierung / Software"
    },
    {
        Id: NOTIFICATION_TYPES.CLARIFICATION_SPARE_PARTS,
        LabelKey: "Klärung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.OTHER,
        LabelKey: "Sonstiges"
    },
    {
        Id: NOTIFICATION_TYPES.MAINTENANCE_REQUEST,
        LabelKey: "Wartungsanfrage"
    },
    {
        Id: NOTIFICATION_TYPES.SPARE_PARTS_ORDER,
        LabelKey: "Bestellung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.APPLICATION_ISSUES,
        LabelKey: "Applikationsthemen"
    }
];
